import axios from 'axios'
import {
  DHT_HOST_API
} from './local.js'
// import VueAxios from 'vue-axios'
const axiosManage = axios.create({
  baseURL: '',
  headers: {
    'token': '40F61D43AEAE8474E80ACC0D68168E89ACD12344C5C7FD472ECCEE966644588E273720671EFD4AAA723207576886B27B946271785C16AD86D97F71A02C87EED6',
    'app_key': 'jyjxs',
    'appVersion': '100683',
    'timestamp': '1539306308809',
    'sign': 'C7E471D17611F478FA9A897328C2AFDC',
    'Content-Type': 'application/json'
  }
})
// axiosManage.defaults.timeout = 1000 * 15
// // axiosManage.defaults.headers.authKey = Lockr.get('authKey')
// // axiosManage.defaults.headers.sessionId = Lockr.get('sessionId')
// axiosManage.defaults.headers.app_key = 'jyjxs'
// axiosManage.defaults.headers.appVersion = '100683'
// axiosManage.defaults.headers.timestamp = '1539306308809'
// axiosManage.defaults.headers.sign = 'C7E471D17611F478FA9A897328C2AFDC'
// axiosManage.defaults.headers.token = '40F61D43AEAE8474E80ACC0D68168E89ACD12344C5C7FD472ECCEE966644588E273720671EFD4AAA723207576886B27B946271785C16AD86D97F71A02C87EED6'
// axiosManage.defaults.headers['Content-Type'] = 'application/json'
export function getUpdateLog (page, limit,code) {
  // let url = 'http://manage-api.baijiuyun.com/system/versionUpdateLog/getListByPage'
  console.log(DHT_HOST_API, 'hah')
  let url = DHT_HOST_API + '/system/versionUpdateLog/getListByPage'
  return axiosManage.get(url, {
    params: {
      sysCode: code,
      page: page,
      limit: limit,
      app_key: 'jyjxs',
      appVersion: '100683',
      status: 1,
      timestamp: '1539306308809',
      sign: 'C7E471D17611F478FA9A897328C2AFDC',
      updateKeyword: '',
      versionStartDate: '',
      token: '40F61D43AEAE8474E80ACC0D68168E89ACD12344C5C7FD472ECCEE966644588E273720671EFD4AAA723207576886B27B946271785C16AD86D97F71A02C87EED6',
    }
  })
}
// 根据更新日志过滤系统产品列表
// export function getUpdateLogList (arr) {
//   let url = API_HOST + 'system/versionUpdateLog/getUserSysProduct'
//   return axiosManage.post(url,  arr)
// }
// 首页--产品更新（升级日志）详情
export function getUpdateLogDetail (id) {
  // let url = 'http://manage-api.baijiuyun.com/system/versionUpdateLog/getById?id=' + id + '&app_key=jyjxs&appVersion=100683&timestamp=1539306308809&sign=C7E471D17611F478FA9A897328C2AFDC&token=40F61D43AEAE8474E80ACC0D68168E89ACD12344C5C7FD472ECCEE966644588E273720671EFD4AAA723207576886B27B946271785C16AD86D97F71A02C87EED6'
  let url = DHT_HOST_API + '/system/versionUpdateLog/getById?id=' + id + '&app_key=jyjxs&appVersion=100683&timestamp=1539306308809&sign=C7E471D17611F478FA9A897328C2AFDC&token=40F61D43AEAE8474E80ACC0D68168E89ACD12344C5C7FD472ECCEE966644588E273720671EFD4AAA723207576886B27B946271785C16AD86D97F71A02C87EED6'
  return axiosManage.get(url)
}

// 获取预警
export function checkAccountValid (params) {
  const url = DHT_HOST_API + '/app/accountManage/checkAccountValid'
  return axiosManage.get(url, {
    params
  })
}